module.exports = __webpack_public_path__ + "img/e22a9de.jpg";